import { Box, Flex, Heading, Text, VStack } from '@chakra-ui/react'
import type { ReactNode } from 'react'

type PageHeaderProps = {
  title: string
  subtitle?: string
  actions?: ReactNode
  /** Center the title/subtitle; any actions float to the top-right. */
  centered?: boolean
}

export function PageHeader({ title, subtitle, actions, centered }: PageHeaderProps) {
  if (centered) {
    return (
      <Box position="relative" mb={6}>
        <VStack gap={1} textAlign="center" maxW="3xl" mx="auto">
          <Heading size="lg">{title}</Heading>
          {subtitle ? <Text color="content.secondary">{subtitle}</Text> : null}
        </VStack>
        {actions ? (
          <Flex gap={2} position="absolute" top={0} right={0}>
            {actions}
          </Flex>
        ) : null}
      </Box>
    )
  }
  return (
    <Flex align="start" justify="space-between" gap={4} mb={6}>
      <VStack align="start" gap={1}>
        <Heading size="lg">{title}</Heading>
        {subtitle ? <Text color="content.secondary">{subtitle}</Text> : null}
      </VStack>
      {actions ? <Flex gap={2}>{actions}</Flex> : null}
    </Flex>
  )
}
